import { useTranslation } from 'react-i18next';

import { Headline } from 'components/Headline';
import { Tooltip } from 'components/Tooltip';

import { Checkboxes } from '../Checkboxes';
import { useOptions } from './Options.hooks';
import * as S from './Options.styles';

export function Options(): React.ReactElement {
  const {
    handleSubmit,
    onSubmit,
    control,
    seasonLineOptions,
    genreOptions,
    genre,
    categories,
    isLoading,
    category,
    isEmailSent,
    setValue,
    marketLine,
    register,
  } = useOptions();
  const { t } = useTranslation();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <S.Container>
        <S.Select
          defaultValue={marketLine}
          control={control}
          name="seasonLine"
          options={seasonLineOptions}
          motive="filter"
          disabled
        />

        <S.Select control={control} name="genre" options={genreOptions} motive="filter" />

        <S.EmailInput
          name="email"
          label={t('pdf.emailForLink')}
          type="email"
          placeholder="Email"
          register={register}
          motive="filter"
        />

        {genre ? (
          <Checkboxes
            values={category}
            control={control}
            data={categories}
            setValue={setValue}
          />
        ) : undefined}

        <Tooltip
          content={
            !genre
              ? 'Please select a genre'
              : genre !== 'all' && (!category || category.length === 0)
              ? t('pdf.selectAtLeastOneCategory')
              : ''
          }
        >
          <S.ActionButton
            isLoading={isLoading}
            type="submit"
            scale="lg"
            motive="actionSecondary"
            disabled={!genre || (genre !== 'all' && (!category || category.length === 0))}
          >
            {t('pdf.createPdf')}
          </S.ActionButton>
        </Tooltip>

        {isEmailSent && !isLoading ? (
          <S.MessageContainer>
            <Headline
              scale="base"
              fontWeight="normal"
              color="grayDarkSecondary"
              className="headline-normal-whitespace"
            >
              {t('pdf.emailSent')}
            </Headline>
            <Headline
              className="headline-normal-whitespace"
              scale="s"
              fontWeight="normal"
              color="grayDarkSecondary"
              tag="p"
            >
              {t('pdf.checkSpam')}
            </Headline>
          </S.MessageContainer>
        ) : undefined}
      </S.Container>
    </form>
  );
}
